import { render } from "./TagManagement.vue?vue&type=template&id=03c4d076"
import script from "./TagManagement.vue?vue&type=script&lang=js"
export * from "./TagManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__